import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../store'

export default function MySelect({
  name,
  values,
  option,
  disabled,
  value,
  setValues,
}: {
  name: string
  values: any
  option: any
  disabled?: boolean | undefined
  value?: any
  setValues: any
}) {
  const [selectedOption, setSelectedOption] = useState<any>(value)

  const handleChange = (event: any) => {
    const selectedId = parseInt(event.target.value)
    const selectedItem = option.find((item: any) => item.id === selectedId)
    setSelectedOption(selectedItem)

    setValues({...values, [`${name}`]: {...value, id: +event.target.value}})
    // values[`${name}`] = +event.target.value
  }
  const store = useSelector((state: RootState) => state.vender)

  return (
    <select
      disabled={disabled}
      style={{
        padding: '15.0625px 13px 12.5px',
        background: 'var(--bs-body-bg)',
        border: '1px solid var(--bs-gray-300)',
        color: ' var(--bs-text-dark)',
        borderRadius: '6.18px',
        width: '100%',
        // backgroundColor: 'var(--bs-gray-100)',
        // borderColor: 'var(--bs-gray-100)',
      }}
      value={selectedOption.id}
      onChange={handleChange}
    >
      <option value={''} disabled hidden>
        select
      </option>
      {option.map((e: any) => (
        <option key={e.id} value={e.id}>
          {e.option_value && (e.option_value[store.lang] || e.option_value[store.defLang])}
        </option>
      ))}
    </select>
  )
}
